// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a4Xu4r_u"};